import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader } from "../../MenuCard";

const ITEMS = [
  { label: "Disponible",          icon: "fas fa-tasks",         color: "#10b981", bg: "#f0fdf4", href: "/ListadoDisponible",         desc: "Stock disponible PT",       perm: "menu_disponible"      },
  { label: "Disponible Vendedor", icon: "fas fa-user-tag",      color: "#3b82f6", bg: "#eff6ff", href: "/ListadoDisponibleVendedor", desc: "Disponible por vendedor",   perm: "disponible_vendedores"},
  { label: "Acumulado Mensual",   icon: "fas fa-calendar-alt",  color: "#f59e0b", bg: "#fffbeb", href: "/ListadoAcumuladoMesnual",   desc: "Acumulado mes actual",      perm: "menu_disponible"      },
  { label: "Disponible MP",       icon: "fas fa-layer-group",   color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoDisponibleMP",       desc: "Materia prima disponible",  perm: "menu_disponible"      },
];

function BotonesDisponibles() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-tasks" color="#10b981" bg="#f0fdf4" title="Inventario Disponible" subtitle="Consultas de disponibilidad de stock" />
        {user.menu_inventarios ? (
          <div className="row">
            {ITEMS.map((r, i) => <MenuCard key={i} {...r} enabled={!!user[r.perm]} />)}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesDisponibles;
